// extracted by mini-css-extract-plugin
export default {"prevWrapper":"_TdZobZx","nextWrapper":"kDCWUfAH","prevIcon":"Pz_Jl_aS","nextIcon":"HGFhtg5U","prev":"gauvmDUP","next":"khFRgpX9"};